/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// FORMAT SELECTOR : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
    noContent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '350px',
        fontSize: pxToEm(24),
        color: theme.color.neutral.dark.swatch,
        border: '2px dashed #c5c5c5',
        borderRadius: pxToEm(10),
        background: 'radial-gradient(ellipse at center, rgba(245,245,245,1) 0%, rgba(232,232,232,1) 100%)',
        '& p':{
            padding: '0 30px',
            '& b':{
                fontWeight: 'bolder'
            }
        }
    }
});